// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
// import router from './router'
import router from './router'
import store from './store/index'
import axios from 'axios'

Vue.config.productionTip = false
// axios.defaults.withCredentials = true
Vue.prototype.$axios = axios
axios.defaults.timeout = 5000
// axios.defaults.baseURL = 'http://47.92.195.211:8082/'
// Vue.prototype.$host = 'http://47.92.195.211:8082/img/'
axios.defaults.baseURL = 'http://www.gogotest.com.cn/auto/'
Vue.prototype.$host = 'http://www.gogotest.com.cn/auto/img/'

// 设置请求头
Vue.use(ElementUI)
Vue.use(store)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js